import { useMutation, UseMutationOptions } from 'react-query';

type ResultData = {
  error: string;
};

type MutationError = Error | Response;

type MutationOptions = UseMutationOptions<ResultData, MutationError>;

const cancelSubscriptionMutation: MutationOptions = {
  mutationFn: async () => {
    const response = await fetch('/api/v1/subscriptions/cancel', {
      method: 'POST',
    });

    if (response.ok) {
      return await response.json();
    } else {
      throw response;
    }
  },
};

export const useCancelSubscription = (
  options?: Omit<MutationOptions, 'mutationFn'>,
) => {
  return useMutation({
    ...options,
    ...cancelSubscriptionMutation,
  });
};
